import styles from "./style.module.scss";
import TopImage from "src/assets/photo-gallery/photo23.jpg";

export const TopSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.backgroundImg}>
        <img src={TopImage} alt="Reservtion" />
        <div className={styles.titleBox}>
          <h1>Reservation</h1>
          <p>ご予約</p>
        </div>
      </div>
    </section>
  );
};
